// Validators should return true if value is valid, otherwise return the error message string.

export const email = value => {
    // eslint-disable-next-line max-len
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(value) || 'Introduzca una dirección de email válida.';
};

export const gte = limit => value => value >= limit || `Asegúrese de que este valor sea mayor o igual a ${limit}.`;
export const gt = limit => value => value > limit || `Asegúrese de que este valor sea mayor a ${limit}.`;
export const lte = limit => value => value <= limit || `Asegúrese de que este valor sea menor o igual a ${limit}.`;
export const lt = limit => value => value < limit || `Asegúrese de que este valor sea menor a ${limit}.`;



// WEBPACK FOOTER //
// ./components/forms/form/validators.js